import { render } from "./CheckboxPicker.vue?vue&type=template&id=33826123&scoped=true"
import script from "./CheckboxPicker.vue?vue&type=script&lang=js"
export * from "./CheckboxPicker.vue?vue&type=script&lang=js"

import "./CheckboxPicker.vue?vue&type=style&index=0&id=33826123&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33826123"

export default script